import React from "react"

export default function HomepageScreenshot({ t, url }) {
  return (
    <div className="bg-surface-card border border-rule rounded-card-lg overflow-hidden">
      <div className="px-5 py-3 border-b border-rule">
        <p
          className="font-mono text-[10px] text-ink-tertiary"
          style={{ letterSpacing: "0.12em" }}
        >
          {t("dashboard.profile.homepage_screenshot_label")}
        </p>
      </div>
      {url ? (
        <div className="bg-surface-subtle" style={{ maxHeight: 480, overflow: "hidden" }}>
          <img
            src={url}
            alt="Homepage"
            className="w-full h-auto block"
            loading="lazy"
          />
        </div>
      ) : (
        <div className="h-[180px] flex items-center justify-center bg-surface-subtle">
          <p className="font-mono text-[11px] text-ink-tertiary" style={{ letterSpacing: "0.12em" }}>
            {t("dashboard.profile.homepage_screenshot_empty")}
          </p>
        </div>
      )}
    </div>
  )
}
